import {
  EnvSection,
  EnvTopic,
} from '@/domain/impact-env/entities/question.entity';

export const envVenueStructureQuizLayout: Record<
  EnvTopic,
  {
    sections: Array<EnvSection>;
  }
> = {
  [EnvTopic.GLOBAL_CO2]: {
    sections: [EnvSection.CO2],
  },
  [EnvTopic.FOOD_BEVERAGES]: {
    sections: [EnvSection.CATERING, EnvSection.BEVERAGES, EnvSection.DISHES],
  },
  [EnvTopic.RESOURCES_POLLUTION]: {
    sections: [
      EnvSection.WATER,
      EnvSection.ENERGY,
      EnvSection.WASTE_ECODESIGN,
      EnvSection.POLLUTION_LOCATION,
    ],
  },
  [EnvTopic.COMMUNICATION]: {
    sections: [
      EnvSection.PHYSICAL_COMMUNICATION,
      EnvSection.DIGITAL_COMMUNICATION,
    ],
  },
  [EnvTopic.PUBLIC_ENGAGEMENT]: {
    sections: [EnvSection.MOBILITY_STRATEGY, EnvSection.PUBLIC_INFORMATION],
  },
  [EnvTopic.EQUIPMENT_AND_SCENOGRAPHY]: {
    sections: [],
  },
};
